/** Shared horizontal inset for primary entity and resource detail tab bars. */
export const ENTITY_DETAIL_TAB_BAR_HORIZONTAL_PADDING = '1rem';
